"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/* istanbul ignore file */

/**
 * Modes for controlling deferred rendering behavior.
 *
 * In general, skipping server side render reduces TTFB, at the expense of the content not being
 * available to users until after page load.
 *
 * In general, delaying hydrate as long as possible reduces FID at the expense of potential flash of
 * content or flash of nothing before content as the page loads or as the user scrolls.
 *
 * In general using Immediate or a Timer with a short delay will break up your render into smaller
 * chunks, reducing worst case blocking time at the expense of total blocking time.
 */
var RenderMode;

(function (RenderMode) {
  RenderMode["RENDER_CLIENT_SIDE_INLINE_SLOW"] = "RENDER_CLIENT_SIDE_INLINE_SLOW";
  RenderMode["RENDER_CLIENT_SIDE_ON_IMMEDIATE"] = "RENDER_CLIENT_SIDE_ON_IMMEDIATE";
  RenderMode["RENDER_CLIENT_SIDE_ON_TIMER"] = "RENDER_CLIENT_SIDE_ON_TIMER";
  RenderMode["RENDER_CLIENT_SIDE_ON_VISIBLE"] = "RENDER_CLIENT_SIDE_ON_VISIBLE";
  RenderMode["RENDER_FOR_BOTS_ONLY"] = "RENDER_FOR_BOTS_ONLY";
  RenderMode["RENDER_SERVER_SIDE_HYDRATE_INLINE_SLOW"] = "RENDER_SERVER_SIDE_HYDRATE_INLINE_SLOW";
  RenderMode["RENDER_SERVER_SIDE_HYDRATE_ON_IMMEDIATE"] = "RENDER_SERVER_SIDE_HYDRATE_ON_IMMEDIATE";
  RenderMode["RENDER_SERVER_SIDE_HYDRATE_ON_TIMER"] = "RENDER_SERVER_SIDE_HYDRATE_ON_TIMER";
  RenderMode["RENDER_SERVER_SIDE_HYDRATE_ON_VISIBLE"] = "RENDER_SERVER_SIDE_HYDRATE_ON_VISIBLE";
  RenderMode["RENDER_SERVER_SIDE_ONLY_NEVER_HYDRATE"] = "RENDER_SERVER_SIDE_ONLY_NEVER_HYDRATE";
})(RenderMode || (RenderMode = {}));

var _default = RenderMode;
exports.default = _default;